<template>
  <div class="ms-container">
    <div class="filters-bar">
      <module-header style="margin-bottom: 0">Акты</module-header>
      <acts-filter :all="true" />
    </div>
    <div class="acts-all">
      <inline-loader :loading="loading" v-if="loading && !nodata" />
      <div class="ms-nodata ms-text" v-else-if="!loading && nodata">
        Не удалось загрузить список актов. Повторите, пожалуйста, попытку позже
      </div>
      <acts-list
        :all="true"
        :acts="acts"
        v-else-if="acts.length"
        @open-act="openAct"
      />
      <div v-else class="ms-nodata ms-text">
        Акты отсутствуют
      </div>
    </div>
  </div>
</template>

<script>
import ModuleHeader from '@/components/parts/module-header'
import ActsList from '@/components/acts/acts-list'
import InlineLoader from '@/components/loaders/inline-loader'
import ActsFilter from '@/components/filters/acts'
import { getActsUrl } from '@/config/filters'

export default {
  components: {
    ModuleHeader,
    ActsList,
    InlineLoader,
    ActsFilter
  },
  data () {
    return {
      loading: false,
      nodata: false,
      acts: []
    }
  },
  watch: {
    '$store.state.filters.acts': {
      handler: function () {
        this.getData(true)
      },
      deep: true
    }
  },
  methods: {
    async getData (noloading) {
      try {
        if (!noloading) this.loading = true
        const url = getActsUrl(`page/act?`, this.$store.state.filters.acts)
        this.acts = await this.$store.dispatch('GET_REQUEST', { url })
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
        this.nodata = true
      }
    },
    openAct ({ id, contract_id }) {
      this.$router.push(`/app/contracts/${contract_id}/acts?open=${id}`)
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style>
</style>
